// extracted by mini-css-extract-plugin
module.exports =  {"tag":"tag--CeGg8","success":"success--w5ST0","primary":"primary--HQQog","danger":"danger--bUjCv","error":"error--Ru2hj","neutral":"neutral--Zaukz","secondary":"secondary--IGJNT"};